import * as Dialog from '@radix-ui/react-dialog';
import { forwardRef, type HTMLAttributes, type ReactNode } from 'react';

import type { ComponentProps } from '~/chords/ComponentProps';
import { getClassNameOverride } from '~/chords/getClassNameOverride';
import { cn } from '~/lib/cn';

interface ModalDialogBodyProps
  extends Omit<
    Dialog.DialogDescriptionProps &
      ComponentProps<HTMLAttributes<HTMLDivElement>>,
    'className'
  > {
  children: ReactNode;
  showCloseButton?: boolean;
}

export const ModalDialogBody = forwardRef<HTMLDivElement, ModalDialogBodyProps>(
  ({ children, ...props }, ref) => {
    const className = getClassNameOverride(props, 'ModalDialog.Body');

    return (
      <Dialog.Description
        ref={ref}
        {...props}
        className={cn('overflow-y-auto px-xl pb-lg pt-sm', className)}
        asChild
      >
        <div>{children}</div>
      </Dialog.Description>
    );
  },
);

ModalDialogBody.displayName = 'ModalDialog.Body';
